<template lang="html">
  <div class="">
    <div class="gap-3x" />
    <div class="section-field flex-box">
      <div>
        <div class="bgap-16">
          Organization: {{ownership.organization_name}}
        </div>
        <div class="bgap-16">
          Organization Admin: {{ownership.admin_email}}
        </div>
        <div class="bgap-16 flex-box vertically-centered">
          <span class="hgap-8-right">Owned Licenses:</span>
          <input
            :value="ownership.licenses"
            @change="(event) => $emit('update', { attribute: 'licenses', value: event.target.value })"
            type="number"
          />
        </div>
        <div class="bgap-16">
          Assigned Licenses: {{ownership.assigned_licenses}}
        </div>
        <div class="error-message big bgap-16" v-if="expireSoon(ownership)">
          Expire Soon
          Notifications Count: {{ownership.notification_count}}
        </div>
        <div class="bgap-16 flex-box vertically-centered">
          <span class="hgap-8-right">Expires (click to edit):</span>
          <DatePicker
            @selected="(selectedDate) => $emit('update', { attribute: 'expires', value: selectedDate })"
            :currentDate="ownership.expires"
          />
        </div>
        <div>
          Status: <strong>{{ownership.status}}</strong> 
        </div>
      </div>
      <div class="flex-box horizontally-end flex-grow-1">
        <SymbiumButton
          text="Save"
          :onClick="() => $emit('save')"
          :isSmall="true"
        />
      </div>
    </div>
    <div class="gap-1x" />
    <SymbiumButton
      text="Destroy"
      :onClick="() => $emit('destroy')"
      :isSmall="true"
      :isPrimary="true"
    />
  </div>
</template>

<script>
import moment from 'moment'

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import DatePicker from 'src/components/common/form/SymbiumDatePicker.vue'

export default {
  components: { DatePicker, SymbiumButton},
  props: ['ownership'],
  methods: {
    expireSoon(ownership) {
      var now = moment();
      var expires = moment(ownership.expires)
      return expires.diff(now, 'days') < 35;
    },
    updateOwnership() {

    }
  }
}
</script>

<style lang="scss" scoped>
.flex-box {
  height: fit-content;

  input {
    max-width: 240px !important;;
  }
}
</style>
